/* eslint-disable camelcase, no-underscore-dangle */
import { FC, useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { selectToken, selectIsLeanUser } from '@redux/slices/userSlice';
import { getHasNewNotificationsKey, useGetNotifications } from '@queries/notifications/notifications';
import { NotificationUI } from './notificationsUI';
import Notifications from './notificationsWrapper';
import './notifications.scss';

const NotificationsContainer: FC<{
    refFunction: React.MutableRefObject<HTMLInputElement>;
    rightSideRef: React.MutableRefObject<HTMLInputElement>;
}> = ({
    refFunction,
    rightSideRef
}: {
    refFunction: React.MutableRefObject<HTMLInputElement>;
    rightSideRef: React.MutableRefObject<HTMLInputElement>;
}) => {
    const perPage = 10;
    const [total, setTotal] = useState<number>(0);
    const [page, setPage] = useState<number>(0);
    const [first, setFirst] = useState<number>(0);
    const [offset, setOffset] = useState<number>(perPage);
    const [notifications, setNotifications] = useState<NotificationUI[]>([]);
    const isLeanUser = useSelector(selectIsLeanUser);

    const token = useSelector(selectToken);
    const queryClient = useQueryClient();

    const { isLoading, data: notificationsResponse } = useGetNotifications(token, first, offset);

    const loadMore = () => {
        const hasMoreNotifications = total > page * perPage;
        if (hasMoreNotifications) {
            setPage(page + 1);
            setFirst(perPage * page);
            setOffset((page + 1) * perPage);
        }
    };

    useEffect(() => {
        if (!(notificationsResponse?.json && notificationsResponse?.json?.notifications)) return;

        const tempNotifications: NotificationUI[] = [...notifications];
        notificationsResponse.json.notifications.forEach((element: any) => {
            const existingIndex = tempNotifications.findIndex(notification => notification.id === element._id);
            const notification = {
                title: element.title,
                date: element.publishedAt,
                content: element.description,
                id: element._id,
                type: element.type
            };

            if (existingIndex !== -1) {
                tempNotifications[existingIndex] = notification;
            } else {
                tempNotifications.push(notification);
            }
        });
        setNotifications(tempNotifications);
        setTotal(notificationsResponse?.json?.total);

        queryClient.setQueryData([getHasNewNotificationsKey, token], {
            json: { success: true, hasNew: false }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notificationsResponse]);

    return (
        <Notifications
            notifications={notifications}
            loadMore={loadMore}
            refFunction={refFunction}
            isEmpty={!isLoading && notifications.length === 0}
            rightSideRef={rightSideRef}
            leanUser={isLeanUser}
        />
    );
};

export default NotificationsContainer;
